import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import './news-and-updates.scss';

import { cmsDocumentList } from '../../../../api/api';

// Assets
// ---------------------
import HeaderImage from '../../../../assets/images/news-and-updates-img.jpg';

// Components
// ---------------------
import { PageHeader } from '../../../../components/page-header/page-header';
import { RSSLink } from '../../../../components/rss-link/rss-link';
import { Article } from '../../../../components/article/article';
import { LoadingSpinner } from '../../../../components/loading-spinner/loading-spinner';
import { Subscription } from '../../../../components/subscription/subscription';

export const NewsAndUpdates = ({ ...props }) => {
  // Header Data
  // -----
  const headerTitle = 'News & Updates';
  const headerText = 'See below for the latest SIGMA X MTF updates';
  const headerImg = (
    <img src={HeaderImage} alt="Sceneic overhead view of a courtyard" />
  );

  // Paths
  // -----
  const params = new URLSearchParams(window.location.search.substring(1));
  const isArchived = params.get('archive');
  const isArchivedParameter = isArchived === '1' ? '&archive=1' : '';
  const rssPath = `/sigmaxmtf/downloadDocuments?downloadType=rss&Id=NewsUpdates${isArchivedParameter}`;
  console.log(
    'news-and-update: params, isArchived, rssPath:',
    params,
    isArchived,
    isArchivedParameter,
    rssPath
  );

  // Get Data
  // -----
  const [isLoading, setIsLoading] = useState(true);
  const [query] = useSearchParams();
  const [data, setData] = useState([]);

  const getArchived = query.get('archive') === '1' ? 1 : 0;
  const archiveText = `View ${getArchived ? 'News & Updates' : 'Archive'}`;
  const archive = (
    <a
      href={`?archive=${getArchived ? 0 : 1}`}
      alt={`View News & Updates${getArchived ? '' : ' Archive'}`}
    >
      {archiveText}
    </a>
  );

  useEffect(() => {
    cmsDocumentList(
      {},
      {
        CmsComponent: 'NewsUpdate',
        IsPublic: 1,
        IsArchived: getArchived,
      }
    ).then((response) => {
      let result = response.data.documents;

      setData(result);
      setIsLoading(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={`news-and-updates-subpage`}>
      <PageHeader
        title={`${headerTitle}${getArchived ? ' / Archive' : ''}`}
        text={headerText}
        img={headerImg}
        link={archive}
        subscription={<Subscription label="To subscribe to announcements, please enter"/>}
      />
      <div className="content-wrapper">
        <RSSLink path={rssPath} aria={`View RSS for ${headerTitle}`} />
        <LoadingSpinner status={isLoading} name={'News & Updates'} />
        <div className="content" hidden={isLoading}>
          {data.map((article, a) => {
            return (
              <Article
                key={`article-${a}`}
                title={article.meta.title}
                content={article.meta.abstract}
                date={article.meta.docDate}
              />
            );
          })}

          <div className="archive-link">{archive}</div>
        </div>
      </div>
    </div>
  );
};
